import { forwardRef, type ComponentPropsWithoutRef, type MouseEvent, type PointerEvent } from 'react';

import { DragHandleButton } from './styled.ts';

export type DragHandleProps = ComponentPropsWithoutRef<typeof DragHandleButton>;

/**
 * The grab handle for a draggable row. Stops click and pointer-down from bubbling to the row, so grabbing or
 * tapping the handle never triggers the row's own behaviour (expand/collapse, onClick). @dnd-kit binds its
 * pointer sensor with a native listener on this element, which fires before React's bubbling — so stopping
 * propagation here doesn't interfere with starting a drag.
 */
export const DragHandle = forwardRef<HTMLButtonElement, DragHandleProps>(function DragHandle({ onClick, onPointerDown, ...props }, ref) {
  return (
    <DragHandleButton
      ref={ref}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      onPointerDown={(event: PointerEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onPointerDown?.(event);
      }}
      {...props}
    />
  );
});
